module.exports = __webpack_public_path__ + "static/media/Korea_Exhibition_02.092861bc.png";